import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  displayField,
  isNotEmpty,
  isEmptyVal,
  processMinute,
  displayTimeField,
} from "../../../utils/helpers";

const OrderItemsCell = ({
  rowData,
  positionFromRight = "50",
  withCustomerNote = true,
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
  withCustomerNote?: boolean;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const orderItems = rowData.order_item_names.split(",");
  const speaker = (
    <Popover title={t("ORDER") + " " + t("ITEMS") + ":"}>
      {orderItems.map((element: string) => {
        if (isNotEmpty(element)) {
          return <p key={element}>{displayField(element)}</p>;
        }
      })}
      <p>
        <b>
          {t("TENTATIVE")} {t("SERVICE")} {t("TIME")}:
        </b>{" "}
        <br />
        {isNotEmpty(rowData.service_starts_at) && (
          <p>
            {t("SERVICE")} {t("STARTS")} {t("AT")}{" "}
            {isNotEmpty(rowData.service_starts_at)
              ? displayTimeField(
                  rowData.service_date + " " + rowData.service_starts_at,
                  false
                )
              : null}
          </p>
        )}
        <p>
          {t("SERVICE")} {t("TIME")} {t("AROUND")}{" "}
          {processMinute(rowData.service_time)}
        </p>
        {isNotEmpty(rowData.service_ends_at) && (
          <p>
            {t("SERVICE")} {t("ENDS")} {t("AT")}{" "}
            {displayTimeField(
              rowData.service_date + " " + rowData.service_ends_at,
              false
            )}
          </p>
        )}
      </p>
      {withCustomerNote && (
        <p>
          <b>
            {t("CUSTOMER")} {t("NOTE")}:
          </b>{" "}
          <br />
          {displayField(rowData.customer_order_note)}
        </p>
      )}
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayField(rowData.order_item_names)}</a>
      </Whisper>
    </Cell>
  );
};

export default OrderItemsCell;
